import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const runVisibilityCheck = (payload) =>
  api.post("/ai-visibility-check", payload).then((r) => r.data);

export const sendOtp = (country_code, phone) =>
  api.post("/otp/send", { country_code, phone }).then((r) => r.data);
export const verifyOtp = (country_code, phone, otp) =>
  api.post("/otp/verify", { country_code, phone, otp }).then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchLeads = () => api.get("/leads").then((r) => r.data);
export const fetchLeadStats = () => api.get("/leads/stats").then((r) => r.data);
export const fetchVisibilityChecks = () => api.get("/visibility-checks").then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  api.patch(`/leads/${id}`, { status }).then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
